/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { AttributeValue, CommerceProperty } from '@msdyn365-commerce/retail-proxy';
// import { toJS } from 'mobx';
import * as React from 'react';
import { IMediaLinksViewProps } from './media-links';

export default (props: IMediaLinksViewProps) => {
    const productSpecificationData = props.data.productSpecificationData.result;
    const values: AttributeValue[] = [];

    productSpecificationData?.map((x: any) => {
        const extensionProps: CommerceProperty[] = [];
        x.ExtensionProperties?.map((ex: any) => {
            const exProp: CommerceProperty = {
                Key: ex.Key,
                Value: ex.Value
            };
            extensionProps.push(exProp);
        });

        const attribute: AttributeValue = {
            AttributeValueId: x.AttributeValueId,
            BooleanValue: x.BooleanValue,
            CurrencyCode: x.CurrencyCode,
            CurrencyValue: x.CurrencyValue,
            DataTypeValue: x.DataTypeValue,
            DateTimeOffsetValue: x.DateTimeOffsetValue,
            ExtensionProperties: extensionProps,
            FloatValue: x.FloatValue,
            IntegerValue: x.IntegerValue,
            KeyName: x.KeyName,
            Name: x.Name,
            RecordId: x.RecordId,
            Swatches: x.Swatches,
            TextValue: x.TextValue,
            UnitOfMeasureSymbol: x.UnitOfMeasureSymbol
        };
        values.push(attribute);
    });

    return (
        <div>
            <h2>Other Options</h2>
            {values.map((value: any, index) =>
                value.TextValue ? (
                    <div key={index}>
                        <a href={value.TextValue}>{value.Name}</a>
                    </div>
                ) : (
                    ''
                )
            )}
        </div>
    );
};
